if (!customElements.get('product-modal')) {
	customElements.define(
		'product-modal',
		class ProductModal extends ModalDialog {
			hide() {
				super.hide();

				// Play videos in slider when closing modal (autoplay doesn't trigger)
				this.modalOpenerVideo = document.querySelectorAll('modal-opener video');
				if (this.modalOpenerVideo.length > 0) {
					this.modalOpenerVideo.forEach((el) => {
						el.play();
					});
				}

				// When closing modal on mobile, if a slide is zoomed, unzoom it and show hidden arrows
				if (
					window.screen.width < 992 &&
					this.querySelector('[data-main-modal-slider] .swiper-slide-zoomed')
				) {
					this.querySelector(
						'[data-main-modal-slider] .swiper-slide-active .swiper-zoom-container',
					).style.transform = '';
					this.querySelector(
						'[data-main-modal-slider] .swiper-slide-active picture',
					).style.transform = 'scale(1)';
					this.querySelector(
						'[data-main-modal-slider] .clrz-swiper--next',
					).style.display = 'block';
					this.querySelector(
						'[data-main-modal-slider] .clrz-swiper--prev',
					).style.display = 'block';
				}
			}

			show(opener) {
				super.show(opener);
				this.showActiveMedia();

				// Play videos in modal when opening it (autoplay doesn't trigger)
				this.videoProductModal = document.querySelectorAll(
					'product-modal video',
				);
				if (this.videoProductModal.length > 0) {
					this.videoProductModal.forEach((el) => {
						el.play();
					});
				}
			}

			showActiveMedia() {
				this.querySelectorAll(
					`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`,
				).forEach((element) => {
					element.classList.remove('active');
				});
				const activeMedia = this.querySelector(
					`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`,
				);
				const activeMediaTemplate = activeMedia.querySelector('template');
				const activeMediaContent = activeMediaTemplate
					? activeMediaTemplate.content
					: null;
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();

				const container = this.querySelector('[role="document"]');
				container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

				if (
					activeMedia.nodeName == 'DEFERRED-MEDIA' &&
					activeMediaContent &&
					activeMediaContent.querySelector('.js-youtube')
				)
					activeMedia.loadContent();
			}
		},
	);
}
